import {get} from "lodash";
import {getBoolean, getInteger, getString} from "Core/helpers/data";
import {SORT_ORDER} from "Core/const/global";

/**
 * Unique Redux store key associated with this reducer
 * IMPORTANT: All reducers must export this value!
 * @type {string}
 */
export const reducerStoreKey = 'userSubmittedQuestionnaires';

// Define reducer types handled by this reducer
export const REDUCER_TYPES = {
	RESET: '@userSubmittedQuestionnaires/reset',
	SET_LIST_DATA: '@userSubmittedQuestionnaires/set_list_data',
	CLEAR_LIST_DATA: '@userSubmittedQuestionnaires/clear_list_data',
	SET_ITEM: '@userSubmittedQuestionnaires/set_item',
	CLEAR_ITEM: '@userSubmittedQuestionnaires/clear_item',
};

// Define action creators for all reducer types
export const actionCreators = {
	reset: () => ({type: REDUCER_TYPES.RESET}),
	/**
	 * @param {IoJsonFetchResponseObject} userSubmittedQuestionnairesListData
	 * @return {{type: string, listData: IoJsonFetchResponseObject}}
	 */
	setUserSubmittedQuestionnairesListData: userSubmittedQuestionnairesListData => ({
		type: REDUCER_TYPES.SET_LIST_DATA,
		listData: userSubmittedQuestionnairesListData
	}),
	clearUserSubmittedQuestionnairesListData: () => ({type: REDUCER_TYPES.CLEAR_LIST_DATA}),
};

/**
 * Initial reducer state
 * IMPORTANT: All reducers must export an initial state object!
 * @type {Object<string, any>}
 */
export const initialState = {
	/** @type {IoJsonFetchResponseObject} */
	listData: null,
	
	/** @type {?PatientStudyInfoDataObject|undefined} */
	study: null,
};

// Reducer function
const reducer = (state = {...initialState}, action) => {
	switch (action.type) {
		case REDUCER_TYPES.RESET: return { ...initialState };

		case REDUCER_TYPES.SET_LIST_DATA: return {...state, listData: action.listData};
		case REDUCER_TYPES.CLEAR_LIST_DATA: return {...state, listData: initialState.listData};

		case REDUCER_TYPES.SET_ITEM: return {...state, item: action.item};
		case REDUCER_TYPES.CLEAR_ITEM: return {...state, item: initialState.item};

		default: return state;
	}
};

// Selectors
export const selectors = {
	getUserSubmittedQuestionnairesList: state => get(state, [reducerStoreKey, 'listData', 'data']),
	getUserSubmittedQuestionnairesListPagination: state => ({
		perPage: getInteger(state, [reducerStoreKey, 'listData', 'perPage']),
		pageNo: getInteger(state, [reducerStoreKey, 'listData', 'pageNo']),
		totalRows: getInteger(state, [reducerStoreKey, 'listData', 'totalResults']),
		isLastPage: getBoolean(state, [reducerStoreKey, 'listData', 'isLastPage'])
	}),
	getUserSubmittedQuestionnairesListSort: state => ({
		sortBy: getString(state, [reducerStoreKey, 'listData', 'sortBy']),
		sortDir: getString(state, [reducerStoreKey, 'listData', 'sortDir'], SORT_ORDER.ASC)
	}),
	getUserSubmittedQuestionnairesListFilter: state => get(state, [reducerStoreKey, 'listData', 'filter'], null),
};

export default reducer;